import * as React from 'react';

export const PendingListContext = React.createContext({}); 
export const EditSurveyContext = React.createContext({}); 
export const DeleteSurveyContext = React.createContext({});
export const DeleteModuleContext=React.createContext({});
export const EditUserContext = React.createContext({}); 


// WEBPACK FOOTER //
// ./src/components/common/context.jsx